import { connect } from "react-redux";
import slugify from "slugify";
import { CardsGrid } from "./styles";
import CardAticle from "../../../components/CardArticle";
import CardNewPost from "../../../components/CardNewPost";
import PostCardSkeleton from "../../../components/PostCardSkeleton";
import { Group } from "../../../../../../types";
import { Post } from "../../../../../../types/post";

interface ComponentProps {
  group: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  posts: Post[];
  postsStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  setLeadMagnetToDelete;
  onShare?: () => void;
}

const Component = ({
  group,
  groupStates,
  posts,
  postsStates,
  setLeadMagnetToDelete,
  onShare
}: ComponentProps) => {


  return !!group ? (
    <>


      {!(posts?.length > 0) && postsStates.loading && (
        <CardsGrid>
          <CardNewPost />
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton />
        </CardsGrid>
      )}

      {posts?.length > 0 && (
        <CardsGrid>
          <CardNewPost />

          {posts.map((post, index) => (
            <CardAticle
              key={slugify(post.title + index, { lower: true })}
              post={post}
              setLeadMagnetToDelete={(idPost) => setLeadMagnetToDelete(idPost)}
              groupInformation={group}
              onShare={onShare}
            />
          ))}
        </CardsGrid>
      )}

      <div style={{ height: 20 }} />
    </>
  ) : (
    <></>
  )
};

const state = ({ groupStore, postStore }) => {
  const { data: posts, states: postsStates } = postStore.listPosts;
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates,
    posts,
    postsStates,
  };
};

export default connect(state)(Component);
